import { createSlice } from "@reduxjs/toolkit";
import { FacultyResponse, SpecialityResponse } from "../../models/dtos";
import { RootState } from "../../store";

const initialState = {
  filters: {
    faculties: [] as FacultyResponse[],
    specialities: [] as SpecialityResponse[],
  },
};

const scheduleSlice = createSlice({
  name: "schedule",
  initialState,
  reducers: {
    setSelectedFaculties: (state, action) => {
      state.filters.faculties = action.payload;
    },
    setSelectedSpecialities: (state, action) => {
      state.filters.specialities = action.payload;
    },
    clearScheduleFilters: (state) => {
      state.filters = initialState.filters;
    },
  },
});

export const { setSelectedFaculties, setSelectedSpecialities, clearScheduleFilters } = scheduleSlice.actions;
export const getSelectedFaculties = (state: RootState) => state.plans.filters.faculties;
export const getSelectedSpecialities = (state: RootState) => state.plans.filters.specialities;

export const getScheduleFilters = (state: RootState) => state.plans.filters;

export const getScheduleFiltersCount = (state: RootState) => {
  return state.plans.filters.faculties.length + state.plans.filters.specialities.length;
};

export default scheduleSlice.reducer;
